import { render, staticRenderFns } from "./Form.html?vue&type=template&id=0fc9bfd0&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"
import style0 from "./Form.scss?vue&type=style&index=0&id=0fc9bfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9bfd0",
  null
  
)

export default component.exports